export const ThTable = ({ Titulo }) => {
    return (
        <th className='p-3 font-bold uppercase bg-blue-900 text-white border border-blue-300 hidden sm:table-cell'>{Titulo}</th>
    )
}
